/* eslint-disable no-template-curly-in-string */

import { getJSON } from 'api/utils/requests';

export default {
  search: getJSON('/platform/inf_users'),
  getUserById: getJSON('/platform/inf_users/${userId}'),
};
